(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-bar"] && !Shopify.designMode) return;
  try {
    
  function initMarquee(trackId) {
    const track = document.getElementById(trackId);
    if (!track || track.dataset.marqueeInit) return;
    track.dataset.marqueeInit = "true";
    const originalContent = track.innerHTML;
    const containerWidth = track.parentElement.offsetWidth;
    while (track.scrollWidth < containerWidth * 2) {
      track.innerHTML += originalContent;
    }
    let position = 0;
    const speed = 0.6;
    function step() {
      position -= speed;
      if (Math.abs(position) >= track.scrollWidth / 2) position = 0;
      track.style.transform = `translateX(${position}px)`;
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  document.addEventListener("DOMContentLoaded", () => initMarquee("marqueeTrack"));

  } catch(e) { console.error(e); }
})();
})();
